import React from 'react';
import { FaDesktop, FaMobile, FaTablet, FaGlobe, FaAndroid, FaApple } from 'react-icons/fa';

const PlatformAnalytics = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center h-32 text-gray-400">
        <p>No platform data available</p>
      </div>
    );
  }

  const totalClicks = data.reduce((sum, item) => sum + item.count, 0);

  const getPlatformIcon = (platform) => {
    switch (platform) {
      case 'android':
        return <FaAndroid className="w-5 h-5 text-green-500" />;
      case 'ios':
        return <FaApple className="w-5 h-5 text-gray-400" />;
      case 'desktop':
        return <FaDesktop className="w-5 h-5 text-blue-500" />;
      case 'mobile':
        return <FaMobile className="w-5 h-5 text-green-500" />;
      case 'tablet':
        return <FaTablet className="w-5 h-5 text-purple-500" />;
      case 'web':
        return <FaGlobe className="w-5 h-5 text-blue-500" />;
      default:
        return <FaGlobe className="w-5 h-5 text-gray-500" />;
    }
  };

  const getPlatformLabel = (platform) => {
    switch (platform) {
      case 'android':
        return 'Android';
      case 'ios':
        return 'iOS';
      case 'desktop':
        return 'Desktop';
      case 'mobile':
        return 'Mobile';
      case 'tablet':
        return 'Tablet';
      case 'web':
        return 'Web';
      default:
        return platform;
    }
  };

  const getPlatformColor = (platform) => {
    switch (platform) {
      case 'android':
        return 'bg-green-500';
      case 'ios':
        return 'bg-gray-400';
      case 'desktop':
        return 'bg-blue-500';
      case 'mobile':
        return 'bg-green-500';
      case 'tablet':
        return 'bg-purple-500';
      case 'web':
        return 'bg-blue-500';
      default:
        return 'bg-gray-500';
    }
  };

  return (
    <div className="flex flex-col h-full">
      <div className="space-y-4 flex-grow">
        {data.map((item, index) => {
          const percentage = totalClicks > 0 ? Math.round((item.count / totalClicks) * 100) : 0;
          return (
            <div key={index} className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                {getPlatformIcon(item.platform)}
                <div className="text-left">
                  <div className="text-white font-medium">{getPlatformLabel(item.platform)} <span className="text-sm text-gray-400">({item.count} clicks)</span></div>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="text-right">
                  <div className="text-white font-semibold">{percentage}%</div>
                </div>
                
                <div className="w-24 bg-gray-700 rounded-full h-2">
                  <div 
                    className={`h-2 rounded-full ${getPlatformColor(item.platform)} transition-all duration-300`}
                    style={{ width: `${percentage}%` }}
                  ></div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      
      {/* Summary */}
      <div className="mt-6 pt-4 border-t border-gray-700">
        <div className="grid grid-cols-2 gap-4">
          <div className="text-left">
            <div className="text-2xl font-bold text-white">{totalClicks}</div>
            <div className="text-sm text-gray-400">Total Clicks</div>
          </div>
          <div className="text-left">
            <div className="text-2xl font-bold text-white">{data.length}</div>
            <div className="text-sm text-gray-400">Platform Types</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformAnalytics;
